import { render, staticRenderFns } from "./file_download.vue?vue&type=template&id=3a1dce84"
import script from "./file_download.vue?vue&type=script&lang=js"
export * from "./file_download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports